import { render } from "./ProjectGanttSection.vue?vue&type=template&id=30fb1ba6&scoped=true&ts=true"
import script from "./ProjectGanttSection.vue?vue&type=script&lang=ts"
export * from "./ProjectGanttSection.vue?vue&type=script&lang=ts"

import "./ProjectGanttSection.vue?vue&type=style&index=0&id=30fb1ba6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30fb1ba6"]])

export default __exports__